module.exports = {"TXTACL_Pick_Your_Game":{"id":"TXTACL_Pick_Your_Game","defaultMessage":"Válassz játékot"}}